/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  ViewChild,
  AfterViewInit
}                                 from '@angular/core';

import { Scenario }               from '@/models/scenario/scenario';
import { ActualTrainSchema }      from '@/models/scenario/actual.train.schema';
import { EvenTrainSchema }        from '@/models/scenario/even.train.schema';
import { ExponentialTrainSchema } from '@/models/scenario/exponential.train.schema';
import { ScheduledTrainSchema }   from '@/models/scenario/scheduled.train.schema';
import { WeeklyTrainSchema }      from '@/models/scenario/weekly.train.schema';
import { Logger         }         from '@/util/logger';
import { PlantTable }             from '@/screens/ide/scenariobrowser/plant.table';
import { TrainTable }             from '@/screens/ide/scenariobrowser/train.table';
import { DwellTable }             from '@/screens/ide/scenariobrowser/dwell.table';
import { TimeTable  }             from '@/screens/ide/scenariobrowser/time.table';
import { Train  }                 from "@/models/scenario/train";
import { StatusReporter }         from '@/util/status.reporter';
import { Tabs }                   from '@/components/tabs';
import { UnDoRedo }               from '@/util/un.do.redo';
import {
  basename,
  empty
}                                 from "@/util/util";

import {BlobType}                 from "@/models/blob";
import {BlobService}              from "@/services/blob.service";
import {AlertService}             from "@/services/alert.service";

import * as $                     from 'jquery';

import KeyDownEvent = JQuery.KeyDownEvent;

import 'gasparesganga-jquery-loading-overlay';

import {first}                    from "rxjs/operators";
import {WorkBlockSchema} from "@/models/scenario/work.block.schema";

@Component({
  selector: 'scenario-browser-component',
  template: `
    <div class="sb-loader-wrapper" (click)="$event.stopPropagation();">

      <div
        class="sb-expander"
        (click)="toggleLoader()"
        [class.disabled]="scenarioKey !== ''"
        [innerHTML]="expanderElement"
        title="Select Scenario">
      </div>

      <div
        class="sb-save-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '')  || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="saveScenario()"
        [innerHTML]="saveScenarioElement"
        title="Save Scenario">
      </div>

      <div
        class="sb-download-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '')  || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="downloadScenario()"
        [innerHTML]="downloadScenarioElement"
        title="Download Scenario">
      </div>

      <div
        class="sb-undo"
        [class.disabled]="undoManager.undoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="undo()"
        [innerHTML]="undoElement"
        title="Undo last change">
      </div>

      <div
        class="sb-redo"
        [class.editorbusy]="editorBusy"
        [class.disabled]="undoManager.redoSize() === 0"
        (click)="redo()"
        [innerHTML]="redoElement" title="Redo last change">
      </div>

      <div class="sb-loader-panel" [class.expanded]="loaderActive">

        <div id="sb-loader-form-drop-area_{{u}}" class="sb-loader-form-drop-area drop-area">

          <p>To select a new scenario, drop a scenario on this dashed area, or click Browse.</p>
          <input
            (change)="onFileBrowse($event.target.files); $event.stopPropagation(); false"
            type="file"
            id="sb-loader-upload_{{u}}"
            class="sb-loader-upload"
            style="display: none !important;">

          <label
            class="gui-button primary"
            for="sb-loader-upload_{{u}}"
            (click)="browseClick($event); $event.stopPropagation(); false">
            Browse
          </label>

        </div>

        <div class="sb-scenario-name">
          <span class="sb-scenario-label">Scenario:</span>
          <span class="sb-scenario-title" [innerHTML]="scenarioTitle"></span>
        </div>

      </div>

    </div>

    <!-- outer shell for the  browser tabs -->
    <div class="scenario-browser-shell" style="text-align:center">

      <div id="sb-scenario-error_{{u}}" class="sb-scenario-error" [innerHTML]="errorLine">
      </div>

      <tabs>
        <tab title="Trains">
          <train-table  uuid={{u}} id="sb_tt_{{u}}"
            (viewPenalty)="onViewPenalty($event)"
            (viewDecisionPoint)="onViewDecisionPoint($event)">
          </train-table>
        </tab>
        <tab title="Plant">
          <plant-table  uuid={{u}} id="sb_pt_{{u}}"></plant-table>
        </tab>
        <tab title="Times">
          <time-table  uuid={{u}} id="sb_tm_{{u}}"></time-table>
        </tab>
        <tab title="Dwell">
          <dwell-table  uuid={{u}} id="sb_dt_{{u}}"></dwell-table>
        </tab>
      </tabs>
    </div>
  `
})

export class ScenarioBrowserComponent implements AfterViewInit, StatusReporter {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum: number = 0;
  public u: number = ScenarioBrowserComponent.instanceNum;

  /** the history manager for the scenario browser */
  public undoManager:           UnDoRedo = new UnDoRedo(`ScenarioBrowserHistory`);

  public    loaderActive: boolean  = false;

  /* the content to show for the expand collapse button */
  public expanderElement: string   = '<i class="fas fa-angle-down"></i>';
  public undoElement:             string = '<i class="fas fa-undo"></i>';
  public redoElement:             string = '<i class="fas fa-redo"></i>';
  public saveScenarioElement:     string = '<i class="far fa-save"></i>';
  public downloadScenarioElement: string = '<i class="fas fa-file-download"></i>';

  /** set to true when actions should be blocked because the editor is busy */
  public editorBusy: boolean       = false;

  /* the visible name of the scenario being browsed */
  public   scenarioTitle: string   = '';

  /** hint for window title, whatever we have for the basename of the scenario file */
  public        fileName: string   = '';

  /* the error feedback if required */
  public       errorLine: string   = '';

  /* the current scenario model */
  public       scenario: Scenario = null;

  /* the object version of the JSON used to load the scenario */
  public           json: any;

  /* blob key of scenario if it was loaded from a blob */
  public    scenarioKey:          string = '';

  @ViewChild(DwellTable, {static: false})
  private dwellTable: DwellTable;

  @ViewChild(TimeTable, {static: false})
  private timeTable: TimeTable;

  @ViewChild(TrainTable, {static: false})
  private trainTable: TrainTable;

  @ViewChild(PlantTable, {static: false})
  private plantTable: PlantTable;

  @ViewChild(Tabs, {static: false})
  private tabs: Tabs;

  /* general call back for when we reload */
  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private blobber: BlobService,
    private alerts:  AlertService
  ) {

    Logger.debug('[scenariobrowser] dynamically creating...');

  }

  /** check to see if the current editing input is good enough to add as a new WorkBlock */
  public canAdd(): boolean {

    if (typeof this.trainTable === 'undefined') {

      return false;
    }

    if ((this.scenario === null) || (this.trainTable === null)) {

      return false;
    }

    return this.trainTable._trainErrors.length === 0;
  }

  ngAfterViewInit(): void {

    /* get the scenario drop box */

    const instanceId: string = `tscb_${this.u}`;

    $('scenario-browser-component').keydown((e: KeyDownEvent) => {

      if (e.key.toLowerCase() === 'escape') {

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

      if (e.ctrlKey && (e.key.toLowerCase() == 'z')) {

        /* undo */

        this.undo();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'y')) {

        /* redo */

        this.redo();

        e.preventDefault();
        e.stopPropagation();

        return false;
      }
    });

    Logger.debug(`[scenariobrowser] setting up drop zone..., instance id=${instanceId}...`);

    /* - - - - - -  add in drag n' drop behaviors */

    /* get the drop box */

    const dropArea: HTMLElement = $(`#sb-loader-form-drop-area_${this.u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#sb-loader-form-drop-area_${this.u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#sb-loader-form-drop-area_${this.u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onFileBrowse(Array.from(dt.files));

    }, false);

    ScenarioBrowserComponent.instanceNum++;

    /* route all the error / status reporting from the tabs through here so we can see everything once. */

    this.trainTable.statusReporter = this;

    this.trainTable.historyManager = (): UnDoRedo => {

      return this.undoManager;
    }

    this.trainTable.onTrainChanged = (train: Train) => {

      /* update other tabs when a train gets edited */

      this.dwellTable.setScenario(this.scenario);

    };

    this.plantTable.statusReporter = this;
    this.timeTable.statusReporter  = this;
    this.dwellTable.statusReporter = this;
  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseClick(e: MouseEvent) {

    document.getElementById(`sb-loader-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** helper to convert the current scenario (and work blocks) into JSON string */
  public toText(): string {

    /*
     * !! NOTE !! to minimize the chance of messing up the scenario some how, we only attempt to
     * overwrite the sections we actually modify.  (currently just the train sub-sections)
     *
     */

    this.json.scenario['trains'] = {};

    /*  actual trains ... */

    if (this.scenario.actualTrains().length > 0) {

      const       s: ActualTrainSchema = new ActualTrainSchema();
      const section: any               = s.render(this.scenario.actualTrains());

      if (section === null) {

        Logger.error(`[scenariobrowser] can't convert to text: ${s.lastError}`);
        return null;
      }

      this.json.scenario['trains']['train_actual'] = section.train_actual;
    }

    /*  even trains ... */

    if (this.scenario.evenTrains().length > 0) {

      const       s: EvenTrainSchema = new EvenTrainSchema();
      const section: any             = s.render(this.scenario.evenTrains());

      if (section === null) {

        Logger.error(`[scenariobrowser] can't convert to text: ${s.lastError}`);
        return null;
      }

      this.json.scenario['trains']['train_even'] = section.train_even;
    }

    /*  exponential trains ... */

    if (this.scenario.exponentialTrains().length > 0) {

      const       s: ExponentialTrainSchema = new ExponentialTrainSchema();
      const section: any                    = s.render(this.scenario.exponentialTrains());

      if (section === null) {

        Logger.error(`[scenariobrowser] can't convert to text: ${s.lastError}`);
        return null;
      }

      this.json.scenario['trains']['train_exponential'] = section.train_exponential;
    }

    /*  scheduled trains ... */

    if (this.scenario.scheduledTrains().length > 0) {

      const       s: ScheduledTrainSchema = new ScheduledTrainSchema();
      const section: any                  = s.render(this.scenario.scheduledTrains());

      if (section === null) {

        Logger.error(`[scenariobrowser] can't convert to text: ${s.lastError}`);
        return null;
      }

      this.json.scenario['trains']['train_scheduled'] = section.train_scheduled;
    }

    /*  weekly trains ... */

    if (this.scenario.weeklyTrains().length > 0) {

      const       s: WeeklyTrainSchema = new WeeklyTrainSchema();
      const section: any             = s.render(this.scenario.weeklyTrains());

      if (section === null) {

        Logger.error(`[scenariobrowser] can't convert to text: ${s.lastError}`);
        return null;
      }

      this.json.scenario['trains']['train_weekly'] = section.train_weekly;
    }

    Logger.debug(`[scenariobrowser] new scenario:`, this.json);

    return JSON.stringify(this.json);
  }

  public saveScenario() {

    if ((this.scenario === null) || (this.scenarioKey === '')  || !this.canAdd()) {

      Logger.debug('[scenariobrowser] can not save right now.');

      return ;
    }

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Saving scenario...");
    this.editorBusy = true;

    const text: string = this.toText();

    Logger.debug(`[scenariobrowser] saving (key='${this.scenarioKey}', sz=${text.length})...`);

    this.blobber.update(this.scenarioKey, text)
      .pipe(first())
      .subscribe(
        () => {

          this.success("Saving complete!");
          this.editorBusy = false;

          Logger.debug('[scenariobrowser] scenario saved.');

        },
        error => {

          this.editorBusy = false;
          this.error("Could not save: " + error);

          Logger.error('[scenariobrowser] can not save scenario: ', error);

          this.alerts.error(error.error.message, {autoClose: true});

        });
  }

  public downloadScenario() {

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Starting download...");

    this.editorBusy = true;

    const text: string = this.toText();

    if (text === null) {

      Logger.debug(`[scenariobrowser] could not convert to text.`);

      this.editorBusy = false;

      return ;
    }

    Logger.debug(`[scenariobrowser] downloading (sz=${text.length})...`);

    const type: BlobType = BlobType.Scenario;
    const mime: string   = 'application/json';

    let keyBase = this.scenarioKey.substring(this.scenarioKey.lastIndexOf('/') + 1);

    if (!keyBase || keyBase === '' ) {

      keyBase = this.scenarioKey;
    }

    /* make a downloadable blob... */

    const blob = new Blob([text], { type: mime });
    const url  = window.URL.createObjectURL(blob);

    /* setup a fake one-time link with the right download name and the blob attached as the download */

    const element: HTMLAnchorElement = document.createElement('a');
    element.href                     = url;
    element.download                 = keyBase || 'download';
    element.style.display            = 'none';

    document.body.appendChild(element);

    /* do it */

    element.click();

    /* clean up */

    document.body.removeChild(element);

    this.editorBusy = false;
  }

  /** update the error line in the loader drop down */
  public status(msg: string =  '') {

    this.errorLine = `<i class="wbedit-info-line">${msg}</i>`;
    Logger.info(`[scenariobrowser] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    this.errorLine = `<i class="wbedit-success-line">${msg}</i>`;
    Logger.debug(`[scenariobrowser] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    this.errorLine = `<i class="wbedit-error-line">${msg}</i>`;
    Logger.error(`[scenariobrowser] ${msg}`);
  }

  public undo() {

    if (this.undoManager.undoSize() === 0) {

      Logger.error(`[scenariobrowser] can not undo right now.`);

      return ;
    }

    Logger.debug(`[scenariobrowser] undo ... `);

    this.undoManager.undo();
  }

  public redo() {

    if (this.undoManager.redoSize() === 0) {

      Logger.error(`[scenariobrowser] can not redo right now.`);

      return ;
    }

    Logger.debug(`[scenariobrowser] redo ... `);

    this.undoManager.redo();
  }

  /** react to the user browsing a local windows scenario file */
  public onFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File = files[0];

    Logger.debug('[scenariobrowser] setting scenario via file: ', upload);

    this.status('');
    this.fileName  = upload.name;

    /* read in the raw text */

    const reader = new FileReader();

    reader.onerror = (msg) => {

      this.error('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      this.fromText(String(text), this.fileName);

    };

    reader.readAsText(upload);
  }

  public fromText(text: string, key: string = '') {

    Logger.debug(`[scenariobrowser] loading from raw text (${key})...`);

    const sb: ScenarioBrowserComponent = this;
    sb.scenarioKey = key;
    sb.json        = null;

    this.fileName = '';

    if (!empty(key)) {

      sb.fileName = basename(key);
    }

    /* convert to JSON */

    let   json = null;

    try {

      sb.json = JSON.parse(text);

    } catch (e) {

      Logger.error('[scenariobrowser] Can not parse scenario JSON: ' + e.getError());
      sb.error('Can not parse scenario JSON: ' + e.getError());

      return ;
    }

    /* try to construct a new model */

    sb.onScenarioLock('Building from JSON...');

    const newScenario: Scenario = new Scenario(sb.json, null, sb);

    this.onScenarioUnlock();

    if (!newScenario.isReady()) {

      Logger.error('[scenariobrowser] Could not read scenario: ' + newScenario.getError());
      sb.error(`Can not build scenario from JSON.`);

      return ;
    }

    Logger.debug('[scenariobrowser] scenario created.');

    /* success */

    setTimeout( () => {

      sb.setScenario(newScenario);

      if (sb.loaderActive) {

        sb.toggleLoader();

      }

      /* let any user of this component know that we have reloaded the view */

      sb.reloaded();

    }, 600);

  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    Logger.debug('[scenariobrowser] locking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    Logger.debug('[scenariobrowser] unlocking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  /** set the scenario using the given JSON */
  public setScenario(s: Scenario) {

    Logger.debug('[scenariobrowser] setting new scenario...');

    this.scenarioTitle = `[<i>${s._author}</i>] ${s._tag}`;
    this.scenario      = s;
    this.status('');

    this.trainTable.setScenario(this.scenario);
    this.plantTable.setScenario(this.scenario);
    this.timeTable.setScenario(this.scenario);
    this.dwellTable.setScenario(this.scenario);
  }

  /** open the scenario loader drop down panel (or close it) */
  public toggleLoader() {

    if (this.loaderActive) {

      /* collapse */

      this.loaderActive    = false;
      this.expanderElement = '<i class="fas fa-angle-down"></i>';

      return ;
    }

    /* expand */

    this.loaderActive    = true;
    this.expanderElement = '<i class="fas fa-angle-up"></i>';
  }

  public onViewPenalty(tcId: number) {

    this.tabs.selectTabByTitle('Times');

    setTimeout(() => {

      this.timeTable.focusOnPenalty(tcId);

    }, 100);
  }

  public onViewDecisionPoint(dpId: number) {

    this.tabs.selectTabByTitle('Plant');

    setTimeout(() => {

      this.plantTable.focusOnDecisionPoint(dpId);

    }, 100);

  }
}
